import BiToolTip from '@/components/charts/biToolTip';
import BiLabel from '@/components/charts/biLabel';
import * as d3 from 'd3';
/* eslint-disable */
const Common = {
  data() {
    // let colorList = [];
    // let i = 0;
    // let l = 360 / 20;
    // while (i < 360) {
    //   colorList.push(d3.hsl(i, 0.55, 0.7).toString());
    //   i += l;
    // }
    return {
      hashId: '',
      classes: {
        data: [],
        options: {}
      },
      classes1: {
        data: [],
        options: {}
      },
      // colorList,
      colorList: [
        // '#FFB574', '#5FC3FE', '#6AECD2', '#FFE85A', '#6FAED1',
        // '#E99D9D', '#ACED6B', '#A7DFEC', '#B8A8E7', '#DCDFE6',
        '#ef5350', '#EC407A', '#AB47BC', '#7E57C2', '#5C6BC0',
        '#42A5F5', '#29B6F6', '#26C6DA', '#26A69A', '#66BB6A',
        '#9CCC65', '#D4E157', '#FFEE58', '#FFCA28', '#FFA726',
        '#FF7043', '#8D6E63', '#78909C',
      ],
      color: null,
      tooltip: {
        title: '',
        desc: [],
        x: 0,
        y: 0
      },
      focus: {
        focusX: 0,
        focusY: 0,
      },
      yLeft: 0,
    };
  },
  components: { BiToolTip, BiLabel },
  props: {
    data: {
      type: Array, default: () => []
    },
    options: {
      type: Object, default: () => ({ domainX: null, classes: null })
    },
    refresh: {
      type: Number, default: 1
    },
    data1: {
      type: Array, default: () => []
    },
  },
  computed: {
    option() {
      return Object.assign({}, this.defaultOptions, this.options);
    },
    clientWidth() {
      return this.option.width !== 0 ? this.option.width : this.$refs.biLineWrap.clientWidth;
    },
    clientHeight() {
      return this.option.height !== 0 ? this.option.height : this.$refs.biLineWrap.clientHeight;
    },
    innerWidth() {
      return this.right - this.left;
    },
    innerHeight() {
      return this.bottom - this.top;
    },
    dataWidth() {
      // x轴如果太宽需要添加横移事件
      let realWidth = 0;
      if (this.option.domainType === 'string' && this.option.domainX && this.option.classes) {
        // realWidth = this.option.domainX.length * 50;
        realWidth = (this.option.domainX.length * this.option.classes.length) * this.defaultBarWidth;
      }
      return realWidth > this.innerWidth ? realWidth : this.innerWidth;
    },
    defaultBarWidth() {
      return !this.options.defaultBarWidth ? this.bar.defaultBarWidth : this.options.defaultBarWidth;
    },
    top() {
      return this.option.margin.top;
    },
    right() {
      return this.clientWidth - this.option.margin.right;
    },
    bottom() {
      return this.clientHeight - this.option.margin.bottom;
    },
    left() {
      return this.option.margin.left + this.yLeft;
    },
    scaleY() {
      return d3.scaleLinear().range([this.bottom, this.top]);
    },
    duration() {
      return this.option.duration || 400;
    },
    message() {
      let message = [];
      let error = '加载失败请点击下方按钮刷新数据';
      if (this.options.error && this.options.error !== '') {
        error = this.options.error;
      }
      message.push(error);
      let loading = '拼命加载中，请稍后。。。。';
      if (this.options.loadingMessage && this.options.loadingMessage !== '') {
        loading = this.options.loadingMessage;
      }
      message.push(loading);
      let str = '数据建设中，请耐心等待';
      if (this.options.message && this.options.message !== '') {
        str = this.options.message;
      }
      message.push(str);
      let emptyMessage = '数据不存在，请更新查询条件';
      if (this.options.emptyMessage && this.options.emptyMessage !== '') {
        emptyMessage = this.options.emptyMessage;
      }
      message.push(emptyMessage);
      // console.log(message);
      return message;
    },
    colors() {
      if (!this.color) {
        if (!this.option.colors) {
          this.color = d3.shuffle(this.colorList);
        } else {
          this.color = this.option.colors;
        }
      }
      return this.color;
    }
  },
  methods: {
    // 友好比例计算——用于柱状图的宽
    getTrueNum(father, percent) {
      let l = 0;
      if (typeof percent === 'number') {
        l = percent > father ? father : percent;
      } else {
        l = father * this.percentToPoint(percent);
      }
      return l;
    },
    // 百分数字符串换算数值
    percentToPoint(percent) {
      let point = percent.replace('%', '').replace(' ', '');
      return point / 100;
    },
    reload() {
      this.$emit('reload');
    },
    changeClassStatus(ix, classes) {
      if (classes && classes[ix]) {
        classes[ix].status = !classes[ix].status;
      }
      return classes;
    },
    getLabel(text, classes) {
      if (classes) {
        for (let i = classes.length - 1; i >= 0; i--) {
          if (classes[i].title === text) {
            return classes[i];
          }
        }
      }
      return [];
    },
    getColor(text, classes = [], noCheck = false) {
      let label = this.getLabel(text, classes);
      let color = label.color;
      color = (label.status || noCheck) ? color : 'none';
      return color;
    },
    getLabelStatus(text, classes = []) {
      let label = this.getLabel(text, classes);
      return label.status ? label.status : 0;
    },
    randomWord(randomFlag, min, max) {
      let str = '';
      let range = min;
      let ary = [];
      for (let i = 48; i < 123; i++) {
        if (i < 58 || i > 64 && i < 91 || i > 97 && i < 123) {
          ary.push(String.fromCharCode(i));
        }
      }
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (let i = 0; i < range; i++) {
        str += ary[Math.round(Math.random() * (ary.length - 1))];
      }
      return str;
    },
    gethashcode() {
      return this.randomWord(false, 16);
    }
  },
  created() {
    this.hashId = this.gethashcode();
  },
};
export default Common;
